import Swiper, {Autoplay, Navigation, Pagination, EffectFade} from 'swiper';
Swiper.use([Autoplay, Navigation, Pagination, EffectFade]);

export default class Home {
    constructor() {
        if (document.getElementById('home') !== null) {
            // this.initHero();
            this.initSocial();
            this.reviewSlider();
            this.servicesSlider();
            this.projectsSlider();
            this.homeSlider();
        }
        this.propertySlider();
    }

    homeSlider() {
        new Swiper('.home-head .swiper-container', {
            slidesPerView: 1,
            autoplay: {
                delay: 3000,
            },
            loop: true,
        });
    }

    // initHero() {
    //     new Swiper('#hero .swiper-container', {
    //         slidesPerView: 1,
    //         allowTouchMove: false,
    //         autoplay: {
    //             delay: 2500,
    //         }
    //     });
    // }

    initSocial() {
        new Swiper('#social .swiper-container', {
            slidesPerView: 1,
            spaceBetween: 10,
            autoplay: {
                delay: 5000,
            },
            breakpoints: {
                576: {
                    slidesPerView: 2,
                },
                768: {
                    slidesPerView: 3,
                },
                1200: {
                    slidesPerView: 4,
                }
            }
        });
    }

    reviewSlider() {
        if (document.querySelector('#reviews')) {
            new Swiper('#reviews .swiper-container', {
                slidesPerView: 1,
                spaceBetween: 20,
                autoplay: {
                    delay: 8000,
                },
                navigation: {
                    nextEl: '#reviews .swiper-button-next',
                    prevEl: '#reviews .swiper-button-prev',
                },
                breakpoints: {
                    360: {
                        spaceBetween: 20
                    },
                    768: {
                        spaceBetween: 20
                    },
                    992: {
                        spaceBetween: 30
                    },
                    1200: {
                        spaceBetween: 30
                    },
                    1400: {
                        spaceBetween: 30
                    },
                }
            });
        }
    }

    servicesSlider() {
        if (document.querySelector('#services')) {
            new Swiper('#services .swiper-container', {
                slidesPerView: 1,
                spaceBetween: 50,
                // loop: true,
                autoplay: {
                    delay: 3000,
                },
                breakpoints: {
                    576: {
                        slidesPerView: 2,
                        spaceBetween: 15
                    },
                    992: {
                        slidesPerView: 4,
                        spaceBetween: 30,
                        loop: false,
                    },

                },
                navigation: {
                    nextEl: '#services .swiper-button-next',
                    prevEl: '#services .swiper-button-prev',
                },
            });
        }
    }

    propertySlider() {
        if (document.querySelector('#properties')) {
            const slider = new Swiper('#properties .swiper-container', {
                sliderPerView: 1,
                spaceBetween: 50,
                breakpoints: {

                    // when window width is >= 640px
                    576: {
                        slidesPerView: 2,
                        spaceBetween: 15
                    },
                    992: {
                        slidesPerView: 3,
                        spaceBetween: 30
                    },

                },
                navigation: {
                    nextEl: '#properties .swiper-button-next',
                    prevEl: '#properties .swiper-button-prev',
                },
            });
            slider.on('slideChangeTransitionStart resize', function() {
                // console.log(slider.slides, slider.realIndex)
                slider.slides.forEach(function(i, index) {
                    if (index < slider.realIndex) {
                        i.classList.add('swiper-slide-prev')
                    }
                })
            })
        }
    }

    projectsSlider() {
        if (document.querySelector('#projects')) {
            const slider = new Swiper('#projects .swiper-container', {

                sliderPerView: 1,
                spaceBetween: 1,
                direction: 'vertical',
                effect: 'slide',
                loop: true,
                autoplay: {
                    delay: 8000,
                    disableOnInteraction: false,
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },

            });
            slider.on('slideChangeTransitionStart resize', function() {
                // console.log(slider.slides, slider.realIndex)
                slider.slides.forEach(function(i, index) {
                    if (index < slider.realIndex) {
                        i.classList.add('swiper-slide-prev')
                    }
                })
            })
        }
    }

}
